import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex items-center gap-5 lg:gap-13',
    tab: 'hover:text-secondary-hover text-inactive min-h-10 cursor-pointer whitespace-nowrap transition-colors',
    title:
      'lg:heading-3xl-desk sm:heading-2xl-desk heading-2xl align-top sm:!leading-none',
    count: 'sm:heading-s heading-xs align-top'
  },
  variants: {
    active: {
      true: {
        tab: 'text-main hover:text-main'
      }
    }
  }
});
